import React, { useState } from "react";

const PERSON_OPTIONS = ["Kimberly", "Adam", "Carissa", "Robert", "Family"];

export default function AddActivitySheet({ onClose, onAdd, defaultPerson = null, lockPerson = false }) {
  const [form, setForm] = useState({
    name: "", person: defaultPerson || "",
    seasonStart: "", seasonEnd: "", location: "", schedule: "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleCreate = async () => {
    if (!form.name.trim()) { setError("Name is required"); return; }
    if (!form.person) { setError("Person is required"); return; }
    setSaving(true); setError("");
    try {
      const res = await fetch("/.netlify/functions/notion", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "createActivity", value: { ...form, name: form.name.trim() } }),
      });
      const data = await res.json();
      if (data.item) { onAdd(data.item); onClose(); }
      else setError("Failed to create activity");
    } catch { setError("Something went wrong"); }
    finally { setSaving(false); }
  };

  return (
    <>
      <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 200 }} />
      <div style={{ position: "fixed", bottom: 0, left: "50%", transform: "translateX(-50%)", width: "100%", maxWidth: "var(--app-max-width)", background: "var(--white)", borderRadius: "20px 20px 0 0", zIndex: 201, paddingBottom: 24, animation: "slideUp 0.25s ease" }}>
        <div style={{ display: "flex", justifyContent: "center", padding: "12px 0 4px" }}>
          <div style={{ width: 36, height: 4, borderRadius: 2, background: "var(--border)" }} />
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 20px 16px", borderBottom: "1px solid var(--border)" }}>
          <button onClick={onClose} style={btn}>Cancel</button>
          <span style={{ fontFamily: "'Playfair Display', serif", fontSize: 16, fontWeight: 600, color: "var(--charcoal)" }}>New Activity</span>
          <button onClick={handleCreate} disabled={saving} style={{ ...btn, color: saving ? "var(--muted)" : "var(--sage)", fontWeight: 800 }}>{saving ? "Creating…" : "Create"}</button>
        </div>
        <div style={{ maxHeight: "65vh", overflowY: "auto" }}>
          {error && <div style={{ padding: "8px 20px", color: "var(--rose)", fontSize: 13, fontWeight: 600 }}>{error}</div>}

          <div style={field}>
            <div style={label}>Name *</div>
            <input autoFocus value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
              placeholder="Activity name…"
              style={{ width: "100%", border: "none", outline: "none", fontSize: 16, fontWeight: 600, color: "var(--charcoal)", fontFamily: "inherit", background: "transparent" }} />
          </div>

          <div style={{ ...field, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={label}>Person *</div>
            {lockPerson ? (
              <div style={{ fontSize: 14, fontWeight: 700, color: "var(--charcoal)" }}>{form.person}</div>
            ) : (
              <select value={form.person} onChange={e => setForm({ ...form, person: e.target.value })} style={sel}>
                <option value="">Select…</option>
                {PERSON_OPTIONS.map(p => <option key={p}>{p}</option>)}
              </select>
            )}
          </div>

          <div style={{ ...field, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={label}>Season Start</div>
            <input type="date" value={form.seasonStart} onChange={e => setForm({ ...form, seasonStart: e.target.value })}
              style={{ border: "none", outline: "none", fontSize: 14, fontWeight: 600, color: "var(--charcoal)", fontFamily: "inherit", background: "transparent" }} />
          </div>

          <div style={{ ...field, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={label}>Season End</div>
            <input type="date" value={form.seasonEnd} onChange={e => setForm({ ...form, seasonEnd: e.target.value })}
              style={{ border: "none", outline: "none", fontSize: 14, fontWeight: 600, color: "var(--charcoal)", fontFamily: "inherit", background: "transparent" }} />
          </div>

          <div style={field}>
            <div style={label}>Location</div>
            <input value={form.location} onChange={e => setForm({ ...form, location: e.target.value })}
              placeholder="Location…"
              style={{ width: "100%", border: "none", outline: "none", fontSize: 15, fontWeight: 500, color: "var(--charcoal)", fontFamily: "inherit", background: "transparent" }} />
          </div>

          <div style={{ ...field, borderBottom: "none" }}>
            <div style={label}>Schedule</div>
            <textarea rows={2} value={form.schedule} onChange={e => setForm({ ...form, schedule: e.target.value })}
              placeholder="Schedule…"
              style={{ width: "100%", border: "none", outline: "none", fontSize: 15, fontWeight: 500, color: "var(--charcoal)", fontFamily: "inherit", background: "transparent", resize: "none", lineHeight: 1.5 }} />
          </div>
        </div>
      </div>
      <style>{`@keyframes slideUp { from { transform: translateX(-50%) translateY(100%); } to { transform: translateX(-50%) translateY(0); } }`}</style>
    </>
  );
}

const btn = { background: "none", border: "none", fontSize: 14, fontWeight: 700, color: "var(--muted)", cursor: "pointer", fontFamily: "inherit" };
const field = { padding: "12px 20px", borderBottom: "1px solid var(--border)" };
const label = { fontSize: 11, fontWeight: 800, letterSpacing: "0.07em", textTransform: "uppercase", color: "var(--muted)", marginBottom: 6 };
const sel = { border: "none", outline: "none", fontSize: 14, fontWeight: 600, color: "var(--charcoal)", fontFamily: "inherit", background: "transparent", cursor: "pointer" };
